import ModalComponent from "../Modal/Modal"
import React, { useEffect, useState } from "react"
import Calendar from "../Calendar/Calendar"
import Input from "../Input/Input"
import Dropdown from "../Dropdown/Dropdown"
import { createSinglePayment, getBankAccountsDropdown, } from "../../features/payment/paymentSlice"
import { useDispatch } from "react-redux"
import { now, dateToServer } from "../../utils/date"
import { showSnackBar } from "../Snackbar/Snackbar"
import { useMyContextLoading } from "../LoadingContextProvider/LoadingContextProvider"

const SinglePaymentModal = ({ userId, alreadyPaid, fetchData, dataPaymentsSchedule }) => {
  const dispatch = useDispatch()
  const [bankUsersDropdown, setBankUsersDropdown] = useState(null)
  const [result, setResult] = useState({
    amount: '',
    dueDate: now(),
    billingAccountId: '',
  })
  const { triggerLoading } = useMyContextLoading()

  const handleInputChange = ({ name, value }) => {
    setResult((prevData) => ({ ...prevData, [name]: value }))
  }

  const getDataBillingInfo = async () => {
    try {
      let bankUsersDropdownData = await dispatch(getBankAccountsDropdown(userId))
      setBankUsersDropdown(bankUsersDropdownData?.payload?.data)
    } catch (error) {
      console.error('An unexpected error occurred:', error)
    }
  }

  const createNewSinglePayment = async () => {
    triggerLoading(true)
    try {
      const body = {
        ...result,
        dueDate: dateToServer(result.dueDate)
      }
      let paymentTypesData = await dispatch(createSinglePayment({ userId, body }))

      paymentTypesData?.payload?.status === "success" ? showSnackBar("success", paymentTypesData?.payload?.message) : showSnackBar("error", "Something went wrong, please double-check the information you entered")
      fetchData()
    } catch (error) {
      console.error('An unexpected error occurred:', error)
    }
    triggerLoading(false)
  }

  useEffect(() => {
    const fetchData = async () => {
      await getDataBillingInfo()
    }

    fetchData()
  }, [])
  return (
    <ModalComponent modalButtonTitle="Submit" title="Single Payment"
      buttonClasses="border !border-primary-main h-10 ml-2" buttonType="outlined"
      buttonTitle='Single Payment' functionButton={createNewSinglePayment}
      subheader={<div className='text-md flex flex-row items-center'>
        <span>Already Paid: </span>
        <span className='mx-3 text-primary-success-600'>${alreadyPaid || 0}</span>

        <span>Total Debt Amount: </span>
        <span className='ml-3 text-primary-main'>${dataPaymentsSchedule[0]?.accountBalance || 0}</span>
      </div>}>
      <Input placeholder={"Indicate single payment amount"}
        parentClassName='mt-6'
        type='Number'
        label='Amount'
        leftSideIcon={<div className="text-text-secondary">$</div>}
        leftSideIconStyle="ml-5 mt-[17px]"
        value={result?.amount}
        onChange={(e) => handleInputChange({ name: 'amount', value: e.target.value })}
      />
      <Dropdown setValue={(e) => handleInputChange({ name: 'billingAccountId', value: e })}
        myListSubheader={[
          { name: 'Bank Accounts', value: 'bankAccounts' },
          { name: 'Credit Cards', value: 'creditCards' }
        ]}
        menuItems={bankUsersDropdown} value={result?.billingAccountId}
        className='my-6' variant='standard' label="Billing Account" />
      <Calendar
        width="w-full"
        label="Billing Date"
        value={result?.dueDate}
        onChange={(val) => handleInputChange({ name: 'dueDate', value: val })}
        isRequired={true}
      />
    </ModalComponent>
  )
}

export default SinglePaymentModal
